import { forwardRef, Heading, HeadingProps } from '@chakra-ui/react';

export const H3 = forwardRef<HeadingProps, 'h3'>((props, ref) => {
    return <Heading as="h3" size="h3" ref={ref} {...props} />;
});
